import * as Sentry from "@sentry/react";
import { applyMiddleware, createStore, compose, Reducer, Store } from "redux";
import thunk from "redux-thunk";

function init(
  reducer: () => Reducer,
  preloadedState: Record<string, unknown> | null = null,
): Store {
  const enhancers = compose(
    applyMiddleware(thunk),
    Sentry.createReduxEnhancer(),
  );

  return preloadedState
    ? createStore(reducer(), preloadedState, enhancers)
    : createStore(reducer(), enhancers);
}

export default init;
